export default __webpack_public_path__ + "static/media/razorpay-logo.50322d2d.png";